// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__22TDG","col":"CardReaderDesc_col__11o6i","label":"CardReaderDesc_label__RFS2D"};